'use client';

import { useRouter } from 'next/navigation';

import { appRoutes } from '@/appRoutes';
import { MainButton } from '@web/ui';

import type { Workspace } from '@web/types';

type AcceptedWorkspace = Pick<Workspace, 'name' | 'slug'>;

type Props = {
  workspace?: AcceptedWorkspace | null;
};

export function SuccessStep({ workspace }: Props) {
  const router = useRouter();

  const handleAccess = () => {
    router.replace(
      workspace?.slug
        ? appRoutes.workspace.index(workspace.slug)
        : appRoutes.home,
    );
  };

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        gap: 16,
      }}
    >
      <div data-testid="success-step-message">
        Awesome! You have joined{' '}
        <strong>{workspace?.name ?? 'an existing Workspace'}</strong>!
      </div>
      <div>
        <MainButton onClick={handleAccess}>Access</MainButton>
      </div>
    </div>
  );
}

SuccessStep.displayName = 'SuccessStep';
